import { useTriggerRhumbSuccess } from './hooks/useTriggerRhumbSuccess';
export default function RhumbSuccessTrigger() {
  useTriggerRhumbSuccess();
  return null;
}